import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IBulkNotificationCampaign, ICreateBulkNotificationCampaignPayload } from '@/interfaces';

type TParams = {
	onSuccess?: () => void;
};

export const useRequestCreateBulkNotificationCampaign = (params?: TParams) => {
	const queryClient = useQueryClient();
	const { isPending, error, mutateAsync } = useMutation({
		mutationKey: [routes.api.bulkNotificationCampaigns.base],
		mutationFn: (data: ICreateBulkNotificationCampaignPayload) =>
			apiClient
				.post<IBulkNotificationCampaign>(routes.api.bulkNotificationCampaigns.base, data)
				.then(handleApiResponse),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [routes.api.bulkNotificationCampaigns.base] });
			params?.onSuccess?.();
		},
	});

	return {
		isLoading: isPending,
		createCampaign: mutateAsync,
		error,
	};
};
